
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/[postId]",
      function () {
        return require("private-next-pages/marketplace/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/[postId]"])
      });
    }
  